"use client";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { trackPageview } from "./client.js";
export function AnalyticsProvider() {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const search = searchParams?.toString() ?? "";
    useEffect(() => {
        if (!pathname)
            return;
        const path = search ? `${pathname}?${search}` : pathname;
        trackPageview(path);
    }, [pathname, search]);
    return null;
}
